<template>
  <div class="transition-global">
    <div
      class="totemBG tw-bg-cover tw-w-screen tw-h-screen tw-flex tw-flex-row"
    >
      <div
        class="tw-flex-1 tw-justify-center tw-items-center tw-self-center tw-place-items-center"
      >
        <BoxAgradecimento @finish="finish" />
      </div>
    </div>
  </div>
</template>

<script>
import anime from "animejs";
import BoxAgradecimento from "@/components/BoxAgradecimento.vue";
import timePage from "@/constants/timeout_page";

export default {
  components: { BoxAgradecimento },
  data() {
    return {
      timerReset: null,
      finished: false,
    };
  },
  mounted() {
    this.animaMounted();
    this.timeToReset();
  },
  beforeDestroy() {
    // Sem isto o timer sobrevivia à tela e empurrava o Totem para a Home no
    // meio de outra etapa.
    clearTimeout(this.timerReset);
  },
  methods: {
    timeToReset() {
      clearTimeout(this.timerReset);
      this.timerReset = setTimeout(() => {
        this.finish();
      }, timePage.AGRADECIMENTO * 1000);
    },
    finish() {
      if (this.finished) return;
      this.finished = true;
      clearTimeout(this.timerReset);
      this.$store.commit("compra/resetCompra");
      this.$router.push("/cabine/home").catch(() => {});
    },
    animaMounted() {
      anime({
        targets: ".transition-global",
        opacity: {
          value: 1,
          delay: 0,
          duration: 1000,
          easing: "easeInOutExpo",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.totemBG {
  background-size: cover;
  background-image: linear-gradient(
      180deg,
      #978fc4 0%,
      #a78ebd 34.84%,
      rgba(207, 138, 172, 0.8) 100%
    ),
    url("../../assets/fundo.png");
}
.transition-global {
  opacity: 0;
}
</style>
